import "./constants/amplify_config";
import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./Layout";

import UserLogin from "./components/UserLogin";
import Feed from "./components/Feed";
import Home from "./components/Home";
import StoryPage from "./components/StoryPage";
import useTokenRefresh from "./components/useTokenRefresh";
import TokenExpiredDialog from "./components/tokenExpiredDialog";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";

export default function App() {
  useTokenRefresh();
  const isTokenExpired = useSelector((state) => state.token.isTokenExpired);
  const [showTokenExpiredDialog, setShowTokenExpiredDialog] = useState(false);
  const idToken = sessionStorage.getItem("idToken");
  if(idToken !== null) {
    const decoded = jwtDecode(idToken);
    const email = decoded.email;
    const username = decoded["cognito:username"];
    if (window.heap) {
      window.heap.identify(username);
      window.heap.addUserProperties({ Name: username, Email: email });
    } else {
      console.warn("Heap is not initialized.");
    }
  }
  
  
  useEffect(() => {
    if (isTokenExpired) {
      setShowTokenExpiredDialog(true);
    }
  }, [isTokenExpired]);
  useEffect(() => {
    // Set "dark" mode in sessionStorage on app load
    sessionStorage.setItem('mode', 'dark');
  }, []);

  const router = createBrowserRouter([
    {
      // parent route component
      element: <Layout />,

      // child route components
      children: [
        {
          path: "/",
          element: <Home />,
        },
        // {
        //   path: "/story",
        //   element: <StoryPage />,
        // },
        // {
        //   path: "/story/:queryID",
        //   element: <StoryPage />,
        // },
        {
          path: "/user/login",
          element: <UserLogin />,
        },
        {
          path: "/user/profile",
        },
        {
          path: "/user/settings",
        },
        {
          path: "/user/logout",
          // action: logoutAction(),
        },
        {
          path: "/user/history/:historyID",
        },
        {
          path: "/:queryID",
        },
        {
          path: "/q/:queryText/story",
          // element: <StoryPage />,
        },
        {
          path: "/feed",
          element: <Feed />,
        },
      ],
    },
  ]);

  return (
    <>
      {showTokenExpiredDialog && (
        <TokenExpiredDialog
          open={showTokenExpiredDialog}
          onClose={() => setShowTokenExpiredDialog(false)}
        />
      )}
      <RouterProvider router={router} />
    </>
  );
}
